import React, { createContext, useContext, useState, useEffect } from 'react'
import { Locale, Translation, translations } from './translations'

interface I18nContextValue {
  locale: Locale
  setLocale: (l: Locale) => void
  t: Translation
}

const I18nContext = createContext<I18nContextValue>({
  locale: 'en',
  setLocale: () => {},
  t: translations.en,
})

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(() => {
    try {
      const saved = localStorage.getItem('rcc_locale') as Locale
      if (saved && translations[saved]) return saved
    } catch {}
    const browser = navigator.language.split('-')[0] as Locale
    return translations[browser] ? browser : 'en'
  })

  const setLocale = (l: Locale) => {
    setLocaleState(l)
    try { localStorage.setItem('rcc_locale', l) } catch {}
  }

  return (
    <I18nContext.Provider value={{ locale, setLocale, t: translations[locale] }}>
      {children}
    </I18nContext.Provider>
  )
}

export function useTranslation() {
  return useContext(I18nContext)
}
